import { render, staticRenderFns } from "./employee-leave.vue?vue&type=template&id=482d5e06&scoped=true"
import script from "./employee-leave.vue?vue&type=script&lang=js"
export * from "./employee-leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482d5e06",
  null
  
)

export default component.exports